import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface DraftTermsState {
  isDraftTermsUpdated: boolean;
}

const initialState: DraftTermsState = {
  isDraftTermsUpdated: false,
};

const devtoolsLocaleSlice = createSlice({
  initialState,
  name: 'devtoolsLocale',
  reducers: {
    setIsDraftTermsUpdated: (state, action: PayloadAction<boolean>) => {
      state.isDraftTermsUpdated = action.payload;
    },
  },
});

export const { setIsDraftTermsUpdated } = devtoolsLocaleSlice.actions;
export default devtoolsLocaleSlice.reducer;
